import { ref, reactive, watch } from 'vue';
import {
  onBeforeRouteUpdate,
} from 'vue-router';

const toggleSize = 721;

const hamburger = reactive({
  isExist: window.innerWidth <= toggleSize,
  isOpen: false,
  initialize,
  show,
  close,
});

const windowWidth = ref(window.innerWidth);

function initialize() {
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
  });

  watch(
    windowWidth,
    (newValue, oldValue) => {
      if (newValue <= toggleSize && oldValue > toggleSize) {
        hamburger.isExist = true;
      }
      if (newValue > toggleSize && oldValue <= toggleSize) {
        hamburger.isExist = false;
      }
    },
  );

  onBeforeRouteUpdate(() => {
    close();
  });
}

function show() {
  hamburger.isOpen = true;
}

function close() {
  hamburger.isOpen = false;
}

export default hamburger;
